/**
 * The DAM hands back an absolute bitstream URL. Only its path (plus query) is
 * persisted in ObjectFields.DsapceVideoUrl, so the stored value does not
 * depend on the DAM host of the environment it was authored in.
 */
export const toRelativeVideoPath = (url?: string): string => {
  if (!url) return "";
  try {
    const { pathname, search } = new URL(url);
    return `${pathname}${search}`;
  } catch {
    return url;
  }
};

/** Inverse of `toRelativeVideoPath`, for playback in the authoring preview. */
export const resolveVideoUrl = (path?: string, baseUrl?: string): string => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || !baseUrl) return path;
  return `${baseUrl.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
};
